export const navLinks = [
  // { label: "Integrations", href: "#" },
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about" },
  { label: "Contact", href: "/contact-us" },
  // { label: "Support", href: "#" },
  { label: "Login", href: "/login" },
];
